import { connect } from 'react-redux';

import { getAlternativeDisplayPrice } from 'redux/modules/product-details/selectors/product-pricing';

import PromotionDescription from './PromotionDescription';

export default connect((state, { productId, promotionId }) => ({
  alternatePrice: getAlternativeDisplayPrice(state, productId, promotionId),
}))(PromotionDescription);
